export default __webpack_public_path__ + "static/media/asparagiTtsIt_It60.24051106.mp3";